import { useEffect, useState } from "react";
import { api } from "@/api/client";
import { Logo } from "@/components/Logo";
import BuildApply from "@/pages/BuildApply";
import BuildApplyV2 from "@/pages/buildApplyV2/BuildApplyV2";

// Bug fix (2026-02): `/build/apply` is the PUBLIC url the founder already shares externally
// (QR codes, ad links, njmpro.com/build) — flipping `application_form_v2_enabled` ON is
// supposed to make THIS exact url swap to serving the v2 wizard live, not just gate the
// separate `/build/apply/v2` url. Previously `/build/apply` and `/build/apply/v2` were two
// hardcoded, independent routes in App.js — the flag was only ever read INSIDE BuildApplyV2
// itself (to gate direct visits to `/v2`), so toggling it had zero effect on `/build/apply`.
// This wrapper is now the ONLY thing that decides which form component `/build/apply` itself
// renders, reading the SAME live `GET /v1/build/apply/v2/status` setting on every mount (no
// build-time baking, no cache — toggling on the backend takes effect on the very next load).
// `/build/apply/v2` stays a separate, always-reachable direct route (its own internal gate in
// BuildApplyV2.jsx is unchanged) — useful for testing/QA regardless of the toggle.
export default function BuildApplyRouter() {
  const [checked, setChecked] = useState(false);
  const [v2Enabled, setV2Enabled] = useState(false);

  useEffect(() => {
    api.get("/v1/build/apply/v2/status")
      .then((r) => setV2Enabled(!!r.data.enabled))
      .catch(() => setV2Enabled(false))
      .finally(() => setChecked(true));
  }, []);

  if (!checked) {
    return (
      <div className="min-h-screen bg-canvas flex items-center justify-center" data-testid="build-apply-router-loading">
        <Logo theme="light" size="lg" iconOnly showBuildLabel />
      </div>
    );
  }
  return v2Enabled ? <BuildApplyV2 /> : <BuildApply />;
}
